import polyglotI18nProvider from 'ra-i18n-polyglot';
import chineseTWMessages from './i18n/zh-TW';

const i18nProvider = polyglotI18nProvider(() => chineseTWMessages, 'zh-TW');

export default i18nProvider;